import * as React from "react";
import {Tab} from 'semantic-ui-react'
import {FtpExplorer} from "./ftp-explorer/FtpExplorer";
import {SFTPTestPage} from "./ftpSync/SFTPTestPage";
import {PageWithSidebar} from "../../../style/page_with_sidebar";
import {ConfigContext} from "../../context/ConfigContext";
import {clampTabIndex} from "../../context/TabSession";


export function FtpTabPage(props: any) {

    const context = React.useContext(ConfigContext)
    const panes = [
        { pos: 1, menuItem: 'Explorer', render: () => <Tab.Pane><FtpExplorer history={props.history}/></Tab.Pane> },
        { pos: 2, menuItem: 'SFTP', render: () => <Tab.Pane><SFTPTestPage /></Tab.Pane> },

    ]

    return <PageWithSidebar activeMenu="FTP">
        <Tab
            id={"FtpTabPage"}
            className={"flexTab"}
            {...props = props}
            panes={panes}
            defaultActiveIndex={clampTabIndex(context.tabSession.ftpTab, panes)}
            onTabChange={(_, data) => {
                context.setSingleTabSession("ftpTab", parseInt(data.activeIndex.toString()), null, null)
            }}
            key={panes.length}
        />
    </PageWithSidebar>
}
